<template>

  <div class="row row-responsive">
    <div class="column column-xs-100 column-sm-100">
        <h4 class="title">Información profesional</h4>
        <div class="row row-responsive">
          <div class="column column-sm-33">
            <span class="title">Importación de productos</span>
            <p class="field">
              {{ verboseBool(professionList.import_products) }}
            </p>
            <span class="title">Actividad</span>
            <p class="field">
              {{ professionList.activity }}
            </p>
          </div>
          <div class="column column-sm-33">
            <span class="title">Exportación de productos</span>
            <p class="field">
              {{ verboseBool(professionList.export_products) }}
            </p>
            <span class="title">Relación de trabajo con otros países</span>
            <p class="field">
              {{ verboseBool(professionList.foreign_relations) }}
            </p>
          </div>
          <div class="column column-sm-33">
            <span class="title">Uso de metales amonedados</span>
            <p class="field">
              {{ verboseBool(professionList.use_metal_coins) }}
            </p>
            <div v-if="this.professionList.foreign_relations">
              <span class="title">Países con relación de trabajo</span>
              <ul v-for="country in professionList.countries" :key="country">
                <li>{{ country }}</li>
              </ul>
            </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import httpRequestMixin from '@/mixins/httpRequestMixin'
export default {
  name: 'UserProfileProfession',
  data () {
    return {
      professionList: []
    }
  },
  mixins: [ httpRequestMixin ],
  methods: {
    verboseBool: function (value) {
      return value ? 'Si' : 'No'
    },
    getUserProfession: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/profile/professions/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }
      const response = await this.httpRequest(options)
      if (response && response.status === 200) {
        this.professionList = response.data
      }
    }
  },
  created: function () {
    this.getUserProfession()
  }
}

</script>



// WEBPACK FOOTER //
// src/views/userProfile/userProfileResume/UserProfileProfession.vue